'use strict';

const FlowCardActionV3 = require('../../HomeyAPIV3/ManagerFlow/FlowCardAction');

class FlowCardAction extends FlowCardActionV3 {

  static transformGet(item) {
    item = super.transformGet(item);

    item.id = `${item.uri}:${item.id}`;
    item.ownerUri = item.uri;
    // I dont know how uriObj can be null but it is possible.
    item.ownerId = item.uriObj != null ? item.uriObj.id : null;
    item.ownerName = item.uriObj != null ? item.uriObj.name : null;
    item.color = item.uriObj != null ? item.uriObj.color : null;
    item.iconObj = item.uriObj != null ? item.uriObj.iconObj : null;

    delete item.uri;
    delete item.uriObj;

    return item;
  }

}

module.exports = FlowCardAction;
